// extracted by mini-css-extract-plugin
export var body = "content-layout-module--body--67f7e";
export var main = "content-layout-module--main--4a95c";